import React from 'react'
import "./StepperSwitch.css"
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';

import ContactForm from './ContactForm';

const FormWrapper = ({ children, index }) => {

    const inquiryTypes = ["Technical Support", "Candidate Support", "Sales Inquiry"]
    return (
        <div className="FormWrapper">
            <div className="header text-[24px] leading-[40px] text-center font-bold mt-[50px] border-b-2 pb-[40px] mb-[20px]">{inquiryTypes[index]}</div>
            {children}
        </div>
    )
}

const steps = ['Technical Support', 'Sales Inquiry'];

const StepperSwitch = () => {
    const [activeStep, setActiveStep] = React.useState(0);
    const [completed] = React.useState({});

    const handleStep = (step) => () => {
        setActiveStep(step);
    };


    return (
        <div className="stepperSwitch  mt-10 sm:w-[40rem] lg:w-[80vw] mx-auto  px-5">

            <div className="stepperContainer w-full mx-auto my-[3.25rem]">
                <Stepper nonLinear activeStep={activeStep} alternativeLabel>
                    {steps.map((label, index) => (
                        <Step key={index} completed={completed[index]}>
                            <StepButton color="inherit" onClick={handleStep(index)}>
                                {label}
                            </StepButton>
                        </Step>
                    ))}
                </Stepper>
            </div>

            <div>

                {
                    activeStep + 1 === 1 ?
                        <FormWrapper index={activeStep}>
                            <ContactForm inquiryType={"tech"} />
                        </FormWrapper>

                        :
                        activeStep + 1 === 2 ?
                            <FormWrapper index={activeStep}>
                                <ContactForm inquiryType={"candidateSupport"} />
                            </FormWrapper>

                            :
                            activeStep + 1 === 3 &&
                            <FormWrapper index={activeStep}>
                                <ContactForm inquiryType={"sales"} />
                            </FormWrapper>

                }



            </div>

        </div>
    )
}

export default StepperSwitch